"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    UnlockId: "U32"
  }
};
exports.default = _default;